<!-- The two-panel dialog from the 2021 build: a panel that says what this is and
     why, and the form beside it. A modal that opens straight onto a stack of
     fields makes the visitor do the work of deciding what the stack is for.

     The panel used to be a photograph at 42% opacity in a 288px column, which
     is not a photograph — it is a grey field with a shape in it. It is now a
     designed surface instead: the site's own ink, the brand set once, and the
     three things the product actually does. Every colour in it comes from the
     palette, and the copy on it measures over 12:1 rather than depending on
     wherever the picture happened to be light.

     The panel folds away below lg, where the form takes the whole dialog. -->
<section class="auth-shell w-100" [class.is-wide]="authState() === AuthStates.REGISTER">
  <aside class="auth-aside section-ink">
    <div class="auth-aside__body">
      <!-- The brand, once. It used to appear here AND as a lockup at the top of
           the form 200px away, saying the same thing two ways. -->
      <app-brand-logo class="auth-aside__brand" [light]="true" size="md"></app-brand-logo>

      <div class="auth-aside__lead">
        @if (authState() === AuthStates.REGISTER) {
        <p class="auth-aside__title">{{ "AUTH.ASIDE.SIGN_UP_TITLE" | translate }} {{ brand.name }}</p>
        <span class="auth-aside__rule"></span>
        <p class="auth-aside__text">{{ "AUTH.ASIDE.SIGN_UP_BODY" | translate }}</p>
        } @else if (authState() === AuthStates.FORGOT_PASSWORD) {
        <p class="auth-aside__title">{{ "AUTH.ASIDE.FORGOT_TITLE" | translate }}</p>
        <span class="auth-aside__rule"></span>
        <p class="auth-aside__text">{{ "AUTH.ASIDE.FORGOT_BODY" | translate }}</p>
        } @else {
        <p class="auth-aside__title">{{ "AUTH.ASIDE.SIGN_IN_TITLE" | translate }} {{ brand.name }}</p>
        <span class="auth-aside__rule"></span>
        <p class="auth-aside__text">{{ "AUTH.ASIDE.SIGN_IN_BODY" | translate }}</p>
        }
      </div>

      <!-- Anchored to the foot of the panel, so the two halves of the dialog
           share a top edge AND a bottom edge instead of one being centred
           against the other. Named, not counted: invented numbers on a demo are
           the fastest way to make the whole thing untrustworthy. -->
      <ul class="auth-aside__marks">
        <li><span class="dot"></span>{{ "LANDING_PAGE.MARKS.VIDEO" | translate }}</li>
        <li><span class="dot"></span>{{ "LANDING_PAGE.MARKS.QUIZ" | translate }}</li>
        <li><span class="dot"></span>{{ "LANDING_PAGE.MARKS.REPORT" | translate }}</li>
      </ul>
    </div>
  </aside>

  <div class="auth-main">
    <div class="dialog-header">
      <h2 class="dialog-title text-gray-900">
        @if(authState() !== AuthStates.UNAUTHORIZED && authState() !==
        AuthStates.AUTHORIZED){

        <app-keenicon name="arrow-left" class="fs-2 cursor-pointer" type="solid" (click)="backToSignIn()"></app-keenicon>
        }
        <!-- {{ "APP.CONFIRM_SHIFT_EXIT" | translate }} -->
      </h2>
      <button type="button" aria-label="Close" class="btn-close" (click)="onClose()"></button>
    </div>
    <div class="dialog-content">
      @if(authState() === AuthStates.UNAUTHORIZED || authState() ===
      AuthStates.AUTHORIZED){
      <app-login></app-login>
      }@else if (authState() === AuthStates.FORGOT_PASSWORD) {
      <app-forgot-password></app-forgot-password>
      }@else if (authState() === AuthStates.REGISTER) {
      <app-registration></app-registration>
      }
    </div>
  </div>
</section>
